import React from "react";

export default class GameBoardFooter extends React.Component {
    public render(): JSX.Element {
        return <div></div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/GameBoardFooter.tsx